import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { Grid, Input, Button } from "@design-system-coopeuch/web";
import Alert from "@coopeuch-components/web/atoms/Alert";
import ExternalSelectAutocomplete from "react-select";
import SimpleCard from "../../molecules/SimpleCard/SimpleCard";
import RadioButtonDropdown from "../../molecules/RadioButtonDropdown/RadioButtonDropdown";
import AddressInput from "../../atoms/NewAddress/NewAddress";
import { StyledWrapperInput, StyledTextOffice } from "./styles";
import IconDelivery from "../../../assets/img/camion-delivery.png";
import IconOffice from "../../../assets/img/in-office.png";
import DatePickerExternal from "../../molecules/DatePickerExternal/DatePickerExternal";
import CustomRadio from "../../molecules/CustomRadio/CustomRadio";
import { useModal } from "../../../hooks/useModal";
import Modal from "../../organisms/Modal/Modal";
import iconCalendar from "../../../assets/img/icon-calendar.svg";
import iconMap from "../../../assets/img/icon-map.svg";
import { constants } from "../../../../domain/constants/index";
import { coverageActions } from "../../../../application/actions/coverage/index";
import { formatNamePreserveAccents } from "../../../../domain/utils/utilitarios-frontend-coopeuch/rut";

const MAX_ANOTHER_DATA = constants.MAX_ANOTHER_DATA;
 /* istanbul ignore next */
const DeliveryAndOffice = (props) => {
  const {
    handleSelectGetCard,
    selectedOptionRadio,
    preferredOffice,
    scheduling,
    sharedDirection,
    optionsDays,
    onChange,
    address,
    disabled,
    coverageData,
  } = props;

  const dispatch = useDispatch();
  /* istanbul ignore next */
  const [optionsHours, setOptionsHours] = useState([]);
  const [selectedDay, setSelectedDay] = useState(
    scheduling.day
      ? {
          day: parseInt(scheduling.day.split("-")[0], 10),
          month: parseInt(scheduling.day.split("-")[1], 10),
          year: parseInt(scheduling.day.split("-")[2], 10),
        }
      : null
  );
  const [selectedHour, setSelectedHour] = useState({});
  const [minimumDate, setMinimumDate] = useState({});
  const [maximumDate, setMaximumDate] = useState({});
  const [disabledDays, setDisabledDays] = useState([]);
  const [selectedOption, setSelectedOption] = useState("home");
  const [isAddressComplete, setIsAddressComplete] = useState(false);
  const [isOpen, openModal, closeModal] = useModal(false);
  const [localAnotherData, setLocalAnotherData] = useState(
    address.anotherData ?? ""
  );

  const { coverage, status } = coverageData;
  /* istanbul ignore next */
  const styleDisabled = {
    color:
      !sharedDirection.trim() || coverage?.code !== "1" ? "#e6e6e6" : "inherit",
    cursor:
      !sharedDirection.trim() || coverage?.code !== "1"
        ? "not-allowed"
        : "inherit",
  };
   /* istanbul ignore next */
  useEffect(() => {
    if (!optionsDays?.length) return;

    const validDates = optionsDays
      .filter((el) => el?.date)
      .map(({ date }) => {
        const [d, m, y] = date.split("-");
        return new Date(y, m - 1, d);
      });

    const min = new Date(Math.min(...validDates));
    const max = new Date(Math.max(...validDates));

    setMinimumDate({
      day: min.getDate(),
      month: min.getMonth() + 1,
      year: min.getFullYear(),
    });

    setMaximumDate({
      day: max.getDate(),
      month: max.getMonth() + 1,
      year: max.getFullYear(),
    });
     /* istanbul ignore next */
    const disabled = [];
    for (let d = new Date(min); d <= max; d.setDate(d.getDate() + 1)) {
      if (!validDates.some((date) => date.getTime() === d.getTime())) {
        disabled.push({
          day: d.getDate(),
          month: d.getMonth() + 1,
          year: d.getFullYear(),
        });
      }
    }
    setDisabledDays(disabled);
  }, [optionsDays]);
   /* istanbul ignore next */
  useEffect(() => {
    if (!minimumDate?.day) return;
    if (selectedDay) return;
    setSelectedDay(minimumDate);
  }, [minimumDate]);
   /* istanbul ignore next */
  useEffect(() => {
    if (!selectedDay) return;
    const formatted = `${("0" + selectedDay.day).slice(-2)}-${(
      "0" + selectedDay.month
    ).slice(-2)}-${selectedDay.year}`;

    const dayData = optionsDays.find((el) => el.date === formatted);
    const hours =
      dayData?.schedule?.map((el) => ({
        value: el.moduleId,
        label: el.description,
      })) ?? [];

    setOptionsHours(hours);
    setSelectedHour({});
    /* istanbul ignore next */
    onChange({
      field: "scheduling",
      property: "value",
      value: {
        ...scheduling,
        day: formatted,
        communeId: dayData?.communeId ?? "",
        regionId: dayData?.regionId ?? "",
        latitude: address?.value?.latitude ?? "",
        longitude: address?.value?.longitude ?? "",
      },
    });
  }, [selectedDay]);
   /* istanbul ignore next */
  const handleRadioChange = (option) => {
    setSelectedOption(option);
    setSelectedHour({});
    setSelectedDay(null);

    dispatch(coverageActions.cleanCoverageStatus());
    if (option === "home") {
      onChange({
        field: "address",
        property: "value",
        value: { ...address.value },
      });
    } else {
     setIsAddressComplete(false);
     resetScheduling();
    }
  };
   /* istanbul ignore next */
  const handleSelectHour = (value) => {
    sessionStorage.setItem("value-hour-scheduling", value?.label);
    setSelectedHour(value);
    onChange({
      field: "scheduling",
      property: "value",
      value: { ...scheduling, hour: value.label, moduleId: value.value },
    });
  };
   /* istanbul ignore next */
  const handleAddressChange = (addr) => {
    const complete = addr.street && addr.numeration && addr.commune && addr.country;
    setIsAddressComplete(complete);
    onChange({
      field: "address",
      property: "value",
      value: { ...address.value, ...addr },
    });
  };
   /* istanbul ignore next */
  const handleChangeAnotherAddress = (value) => {
    setLocalAnotherData(value);
    onChange({ field: "address", property: "anotherData", value });
  };
   /* istanbul ignore next */
  const handleOptionGetCard = (option) => {
    if (option === "sucursal") {
      setSelectedOption("home");
      setIsAddressComplete(false);
      resetScheduling();
    }
    if (
      option === "domicilio" &&
      sharedDirection?.trim() &&
      !optionsDays.length
    ) {
      onChange({
        field: "address",
        property: "rehydrate",
        value: { ...address.value },
      });
    }
    handleSelectGetCard(option);
  };
   /* istanbul ignore next */
  const resetScheduling = () => {
    setSelectedDay(null);
    setSelectedHour({});
    setOptionsHours([]);
    onChange({
      field: "scheduling",
      property: "value",
      value: { moduleId: "", regionId: "", communeId: "", day: "", hour: "" },
    });
    dispatch(coverageActions.cleanCoverageStatus());
  };
   /* istanbul ignore next */
  useEffect(() => {
    const v = address?.value ?? {};
    const complete = !!(v.street && v.numeration && v.commune && v.country);
    if (!complete) {
      resetScheduling();
    }
  }, [
    address?.value?.street,
    address?.value?.numeration,
    address?.value?.commune,
    address?.value?.country,
  ]);
   /* istanbul ignore next */
  useEffect(() => {
    if (selectedOptionRadio)
      sessionStorage.setItem("option-tarjeta", selectedOptionRadio);
  }, [selectedOptionRadio]);
   /* istanbul ignore next */
  useEffect(() => {
    if (
      selectedOption === "home" &&
      selectedOptionRadio === "domicilio" &&
      sharedDirection?.trim() &&
      !optionsDays.length
    ) {
      onChange({
        field: "address",
        property: "rehydrate",
        value: { ...address.value },
      });
    }
  }, [selectedOption]);
   /* istanbul ignore next */
  const handleOpenModal = () => {
    openModal();
  };
   /* istanbul ignore next */
  const handleCloseModal = () => {
    closeModal();
  };
  /* istanbul ignore next */
  return (
    <div>
      <SimpleCard
        contentHeader={
          <p className="simplecard__title">Entrega de tu Tarjeta de Débito</p>
        }
        disabled={disabled}
      >
        <Grid className="m-0 p-2 p-md-6 position-static">
          {(status === null || selectedOptionRadio === "sucursal") && (
            <Alert show bgType="info">
              <p style={{ color: "#007DB7" }}>
                <strong style={{ fontSize: "14px" }}>Importante:</strong> Solo
                la persona titular podrá recibir la tarjeta presentando su
                cédula de identidad.
              </p>
            </Alert>
          )}

          {status === 1 && selectedOptionRadio === "domicilio" && (
            <Alert show bgType="info">
              <p style={{ fontSize: "14px", color: "#007DB7" }}>
                <strong>
                  La dirección ingresada no se encuentra en el área de cobertura
                  de despacho.
                </strong>
                <br />
                Ingresa una nueva dirección para recibir tus productos.
              </p>
            </Alert>
          )}

          <Grid className="p-0 mb-2 pt-5">
            <p className="font-size-16 line-height-24 font-weight-bold">
              Selecciona una opción de despacho:
            </p>
          </Grid>

          <CustomRadio
            name="deliveryOption"
            value="domicilio"
            title="Despacho a domicilio"
            subtitle="Enviaremos tu Tarjeta de Débito a la dirección que escojas"
            icon={IconDelivery}
            selected={selectedOptionRadio === "domicilio"}
            onChange={() => handleOptionGetCard("domicilio")}
          />

          <CustomRadio
            name="sucursalOption"
            value="sucursal"
            title={`Retiro en sucursal Coopeuch ${formatNamePreserveAccents(
              preferredOffice?.value.commune
            )}`}
            subtitle="Podrás retirar tu tarjeta de débito en un plazo de 3 días hábiles."
            icon={IconOffice}
            selected={selectedOptionRadio === "sucursal"}
            onChange={() => handleOptionGetCard("sucursal")}
          />

          {selectedOptionRadio === "domicilio" && (
            <div>
              <Grid className="p-0 mb-2 pt-5">
                <p className="font-size-16 line-height-24 font-weight-bold">
                  ¿Dónde quieres recibir tu tarjeta?
                </p>
              </Grid>

              <RadioButtonDropdown
                id={1}
                hasContent={false}
                name={"home"}
                label={
                  sharedDirection ? `En mi domicilio: ${sharedDirection}` : ""
                }
                checked={selectedOption === "home"}
                onChange={() => handleRadioChange("home")}
                disabled={false}
              />

              <RadioButtonDropdown
                id={2}
                hasContent={true}
                name={"new"}
                label="En otra dirección"
                checked={selectedOption === "new"}
                onChange={() => handleRadioChange("new")}
              >
                <fieldset
                  disabled={selectedOption !== "new"}
                  style={{ opacity: selectedOption !== "new" ? 0.6 : 1 }}
                >
                  <Grid row className="p-0 pt-4 align-items-center" col={12}>
                    <Grid className="p-0 mb-2 mb-md-2" col={12} md={8}>
                      <AddressInput
                        label="Dirección (con calle y número)"
                        addressObject={address.value}
                        onDoSomething={handleOpenModal}
                        onChange={handleAddressChange}
                        coverage={coverage}
                      />
                    </Grid>

                    <Grid className="p-0 px-md-2 mb-2">
                      <StyledWrapperInput>
                        <Input
                          value={localAnotherData}
                          maxLength={MAX_ANOTHER_DATA}
                          label="Depto/Block/Parcela/Otro"
                          placeholder="Ejemplo: Parcela 6"
                          assistText="Opcional"
                          allowSpaces
                          autoComplete="new-password"
                          onChange={(value) => handleChangeAnotherAddress(value)}
                        />
                      </StyledWrapperInput>
                    </Grid>
                  </Grid>
                </fieldset>
              </RadioButtonDropdown>

              {/* ** Calendar agendamiento ** */}
              <Grid className="m-0 p-2 p-md-6 border-top border-neutral-alfa-15 position-static">
                <Grid className="p-0 mb-2 mb-md-3">
                  <p
                    className="font-size-14 font-weight-bold"
                    style={styleDisabled}
                  >
                    ¿Cuándo quieres recibir tus tarjetas?
                  </p>
                </Grid>

                <Grid row className="m-0 p-0 py-1">
                  <Grid
                    className="w-50 p-0 pr-md-1 mb-2 mb-md-0 mr-0 mr-md-1"
                    col={12}
                    md={4}
                  >
                    <label
                      htmlFor="fecha_entrega"
                      className="label-select-autocomplete"
                      style={styleDisabled}
                    >
                      Fecha de entrega
                    </label>

                    <DatePickerExternal
                      id="fecha_entrega"
                      inputPlaceholder="DD/MM/AAAA"
                      inputClaseName="datepicker-coopeuch__input"
                      calendarClassName="datepicker-coopeuch"
                      value={selectedDay}
                      disabledDays={disabledDays}
                      minimumDate={minimumDate}
                      maximumDate={maximumDate}
                      onChange={setSelectedDay}
                      disabled={
                        !sharedDirection.trim() ||
                        coverage?.code !== "1" ||
                        (selectedOption === "new" && !isAddressComplete)
                      }
                    />
                    <img
                      alt="date"
                      src={iconCalendar}
                      className="datepicker-icon-calendar"
                    />
                  </Grid>

                  <Grid
                    className="w-50 p-0 pl-md-1 position-static"
                    col={12}
                    md={4}
                  >
                    <label
                      htmlFor="seleccionar_horario"
                      className="label-select-autocomplete"
                      style={styleDisabled}
                    >
                      Horario de entrega
                    </label>

                    <ExternalSelectAutocomplete
                      id="seleccionar_horario"
                      className="select-autocomplete-coopeuch external-select-autocomplete"
                      classNamePrefix="select-autocomplete-coopeuch"
                      placeholder="Seleccione una hora"
                      noOptionsMessage={() => "Sin opciones"}
                      value={selectedHour}
                      onChange={handleSelectHour}
                      isDisabled={
                        !selectedDay ||
                        (selectedOption === "new" && !isAddressComplete)
                      }
                      options={optionsHours}
                    />
                  </Grid>

                  <br />
                </Grid>
              </Grid>

              {status === 1 && (
                <Grid
                  className="w-55 pl-md-6 mb-20"
                  style={{
                    opacity: coverage?.code !== "1" ? 0.6 : 1,
                    marginBottom: "30px",
                  }}
                >
                  <Alert show bgType="warning">
                    <strong style={{ fontSize: "14px" }}>
                      Importante: Sólo tú puedes recibir tu tarjeta, con tu
                      cédula de identidad en mano.
                    </strong>
                  </Alert>
                </Grid>
              )}
            </div>
          )}

          {selectedOptionRadio === "sucursal" && (
            <StyledTextOffice>
              <ul className="info-office-selected">
                <li className="li-office-selected">
                  La sucursal ingresada se encuentra ubicada en{" "}
                  {formatNamePreserveAccents(preferredOffice.value.address)}{" "}
                  {formatNamePreserveAccents(preferredOffice.value.commune)}
                  <br />
                  Si deseas cambiarla, puedes hacerlo regresando al paso
                  anterior.
                </li>
              </ul>
            </StyledTextOffice>
          )}
        </Grid>
      </SimpleCard>

      <Modal
        isOpen={isOpen}
        closeModal={handleCloseModal}
        closeClickOutside
        closeEscKey
        className={classNames("modal-address-imput")}
      >
        <Grid
          row
          className="d-flex flex-column justify-content-center align-items-center"
        >
          <Grid
            col={12}
            md={8}
            className="p-5 d-flex flex-column justify-content-center align-items-center"
          >
            <img src={iconMap} alt="" width="140" className="mt-3" />
            <p className="text-center mt-2 mb-3 font-size-18 font-weight-500">
              Recuerda ingresar calle con número y selecciona una opción de la
              lista.
            </p>
            <article>
              <p className="text-center mb-3">
                Ejemplo: Agustinas 1141, Santiago
              </p>
              <p className="text-center line-height-20">
                Si no encuentras tu dirección en la lista, contáctanos al 600
                200 1200.
              </p>
            </article>
          </Grid>
        </Grid>
        <Grid className="p-5 border-top border-neutral-alfa-15 d-flex justify-content-center align-items-center">
          <Button
            disabled={false}
            onClick={handleCloseModal}
            color="secondary"
            className="text-align-center"
            variant="default"
          >
            Entendido
          </Button>
        </Grid>
      </Modal>
    </div>
  );
};

DeliveryAndOffice.defaultProps = {
  sharedDirection: "",
  disabled: false,
  preferredOffice: {
    value: {
      commune: "",
      address: "",
    },
  },
  selectedOptionRadio: "domicilio",
  handleSelectGetCard: () => null,
};

DeliveryAndOffice.propTypes = {
  handleSelectGetCard: PropTypes.func,
  selectedOptionRadio: PropTypes.string,
  preferredOffice: PropTypes.shape({
    value: PropTypes.shape({
      commune: PropTypes.string,
      address: PropTypes.string,
    }),
  }),
  scheduling: PropTypes.shape({
    moduleId: PropTypes.string,
    communeId: PropTypes.any,
    regionId: PropTypes.any,
    day: PropTypes.any,
    hour: PropTypes.any,
  }).isRequired,
  sharedDirection: PropTypes.string,
  optionsDays: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  address: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  coverageData: PropTypes.object.isRequired,
};

export default DeliveryAndOffice;